/* eslint-disable */

import {
  //Company objects api  Объектов (компаний)
  getMonitoringObject,
  getAllObjectCompany,
  getAllObjectCompanyMap,
  addObjectCompany,
  getObjectCompanyWithFilters,
  editObjectCompany,
  deleteObjectCompany,
  getObjectCompany,
  getAllMapMonitoringDetail,
  getAllMapMonitoring,
  getExpertiseList,
  editExpertiseSave,
  getExpertiseListMain,
  getObjectByInn, // не работает
  getObjectPollutionSourceForMapWater,
  //Pollution source api Источник загрязнений
  getObjectPollutionSourceForMap,
  getObjectPollutionSourceDiagrams,
  getObjectPollutionSource,
  addObjectPollutionSource,
  editObjectPollutionSource,
  deleteObjectPollutionSource, // для удаления источников
  getAllObjectPollutionSource,
  getAllObjectPollutionSourcesForMap,
  //Pollution source Normative api Компонентов Источников  загрязнения
  getObjectPollutionSourceNormative,
  addObjectPollutionSourceNormative,
  editObjectPollutionSourceNormative,
  deleteObjectPollutionSourceNormative,
  getSelectObjectSourcesList,
  getAllMapMonitoringMap,
  getAllMapMonitoringMapConfirmation,
  getObjectPollutionSourceNormativeCharts,
  //API для получения всех комопнентов по источнику
  getComponentsByPollutionSource,
  getObjectPollutionSourceForMapMonitoring,
  getObjectCountCompanyRegion, getAllObjectPollutionSourcesForMapId

  // getAllObjectPollutionSourceNormative,
  // //ObjectDailyPollutionEmissions api Отправка на модерацию данных
  // getObjectDailyPollutionEmissions,
  // addObjectDailyPollutionEmissions,
  // editObjectDailyPollutionEmissions,
} from "../../api/objects";

export default {
  /////////////////
  // Company objects
  /////////////////
  fetchAllCompanyObject({commit}, a) {
    return new Promise((resolve, reject) => {
      getAllObjectCompany(a)
        .then(res => {
          commit("SET_COMPANY_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllCompanyObjectMap({commit}, a) {
    return new Promise((resolve, reject) => {
      getAllObjectCompanyMap(a)
        .then(res => {
          commit("SET_COMPANY_OBJECTS_MAP", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchCompanyObject({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectCompany(a)
        .then(res => {
          commit("SET_COMPANY_OBJECTS2", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchListExpertise({commit}, a) {
    return new Promise((resolve, reject) => {
      getExpertiseList(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchListExpertiseMain({commit}, a) {
    return new Promise((resolve, reject) => {
      getExpertiseListMain(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchListCompanyObjectWithFilter({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectCompanyWithFilters(a)
        .then(res => {
          commit('SET_SELECT_LIST', res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addCompanyObject({commit}, a) {
    return new Promise((resolve, reject) => {
      addObjectCompany(a)
        .then(res => {
          commit("ADD_COMPANY_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editExpertiseSave({commit}, a) {
    return new Promise((resolve, reject) => {
      editExpertiseSave(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editCompanyObject({commit}, a) {
    return new Promise((resolve, reject) => {
      editObjectCompany(a)
        .then(res => {
          commit("EDIT_COMPANY_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteCompanyObject({commit}, a) {
    return new Promise((resolve, reject) => {
      deleteObjectCompany(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // getCompanyObject({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     getObjectCompany()
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // },

  /////////////////
  //Polution Source добавление источников загрязнения
  /////////////////
  fetchPollutionSourceObjectForMap({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSourceForMap(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchPollutionSourceObjectForMapMonitoring({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSourceForMapMonitoring(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchPollutionSourceObjectForMapWater({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSourceForMapWater(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchMonitoringObject({commit}, a) {
    return new Promise((resolve, reject) => {
      getMonitoringObject(a)
        .then(res => {
          commit("SET_MONITORING_OBJECT", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchPollutionSourceObject({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSource(a)
        .then(res => {
          commit("SET_POLLUTION_SOURCE_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchPollutionSourceObjectDiagrams({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSourceDiagrams(a)
        .then(res => {
          commit("SET_POLLUTION_SOURCE_OBJECTS_DIAGRAMS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllPollutionSourceObject({commit}) {
    return new Promise((resolve, reject) => {
      getAllObjectPollutionSource()
        .then(res => {
          commit("SET_ALL_POLLUTION_SOURCE_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllPollutionSourceObjectForMap({commit}, a) {
    return new Promise((resolve, reject) => {
      getAllObjectPollutionSourcesForMap(a)
        .then(res => {
          //commit("SET_ALL_POLLUTION_SOURCE_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllMapMonitoringMapConfirmation({commit}, a) {
    return new Promise((resolve, reject) => {
      getAllMapMonitoringMapConfirmation(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllMapMonitoringMap({commit}, a) {
    return new Promise((resolve, reject) => {
      getAllMapMonitoringMap(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllMapMonitoringDetail({commit}, a) {
    return new Promise((resolve, reject) => {
      getAllMapMonitoringDetail(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllMapMonitoring({commit}, a) {
    return new Promise((resolve, reject) => {
      getAllMapMonitoring(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllPollutionSourceObjectForMapId({commit}, id) {
    return new Promise((resolve, reject) => {
      getAllObjectPollutionSourcesForMapId(id)
        .then(res => {
          //commit("SET_ALL_POLLUTION_SOURCE_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchObjectByInn({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectByInn(a)
        .then(res => {
          //commit("SET_ALL_POLLUTION_SOURCE_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  addPollutionSourceObject({commit}, a) {
    return new Promise((resolve, reject) => {
      addObjectPollutionSource(a)
        .then(res => {
          commit("ADD_POLLUTION_SOURCE_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  editPollutionSourceObject({commit}, a) {
    return new Promise((resolve, reject) => {
      editObjectPollutionSource(a)
        .then(res => {
          commit("EDIT_POLLUTION_SOURCE_OBJECTS", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deletePollutionSourceObject({commit}, a) {
    return new Promise((resolve, reject) => {
      deleteObjectPollutionSource(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /////////////////
  //Polution Source Normatives добавление компонентов для источников загрязнения
  /////////////////
  fetchPollutionSourceObjectNormative({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSourceNormative(a)
        .then(res => {
          commit("SET_POLLUTION_SOURCE_NORMATIVE", {
            data: res.data.data,
            source_id:
            a.source_id /*отправляю в мутацию ответ из бэка и ID источника  */
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchSelectPollutionSourceObjectNormative({commit}, a) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSourceNormative(a)
        .then(res => {
          commit("SET_SELECT_POLLUTION_SOURCE_NORMATIVE", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllPollutionSourceObjectNormative({commit}) {
    return new Promise((resolve, reject) => {
      getAllObjectPollutionSourceNormative()
        .then(res => {
          commit("SET_ALL_POLLUTION_SOURCE_NORMATIVE", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  addPollutionSourceObjectNormative({commit}, a) {
    return new Promise((resolve, reject) => {
      addObjectPollutionSourceNormative(a)
        .then(res => {
          commit(
            "ADD_POLLUTION_SOURCE_NORMATIVE",
            {
              data: res.data,
              source_id: a.sources
            } /*отправляю в мутацию ответ из бэка и ID источника  */
          );
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  editPollutionSourceObjectNormative({commit}, a) {
    return new Promise((resolve, reject) => {
      editObjectPollutionSourceNormative(a)
        .then(res => {
          commit(
            "EDIT_POLLUTION_SOURCE_NORMATIVE",
            {
              data: res.data,
              source_id: a.sources
            } /*отправляю в мутацию ответ из бэка и ID источника  */
          );
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deletePollutionSourceObjectNormative({commit}, a) {
    return new Promise((resolve, reject) => {
      deleteObjectPollutionSourceNormative(a)
        .then(res => {
          commit(
            "DELETE_POLLUTION_SOURCE_NORMATIVE",
            {
              data: a.data,
              source_id: a.source.id
            } /*отправляю в мутацию ответ из бэка и ID источника  */
          );
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchComponentsByPollutionSource({commit}, a) {
    return new Promise((resolve, reject) => {
      getComponentsByPollutionSource(a)
        .then(res => {
          // commit("EDIT_POLLUTION_SOURCE_NORMATIVE",  {data:res.data.data, source_id: a.source_id}  /*отправляю в мутацию ответ из бэка и ID источника  */);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchSelectObjectSourcesList({commit}, id) {
    return new Promise((resolve, reject) => {
      getSelectObjectSourcesList(id)
        .then(res => {
            commit("SET_SELECT_OBJECT_SOURCES_LIST", res.data.data);
            resolve(res);
          }
        )
        .catch(err => {
            reject(err);
          }
        );
    });
  },

  fetchObjectPollutionSourceNormativeCharts({commit}, id) {
    return new Promise((resolve, reject) => {
      getObjectPollutionSourceNormativeCharts(id)
        .then(res => {
            commit("SET_OBJECT_POLLUTION_SOURCE_NORMATIVE_CHARTS", res.data.data);
            resolve(res);
          }
        )
        .catch(err => {
            reject(err);
          }
        );
    });
  },


  fetchObjectCountCompanyRegion({commit}, params) {
    return new Promise((resolve, reject) => {
      getObjectCountCompanyRegion(params)
        .then(res => {
            commit("SET_OBJECT_COUNT_COMPANY_REGION", res.data.data);
            resolve(res);
          }
        ).catch(err => {
          reject(err);
        }
      );
    });
  }

  // // ObjectDailyPollutionEmissions

  // fetchDailyPollutionEmissions({ commit }, a) {
  //   return new Promise((resolve, reject) => {
  //     getObjectDailyPollutionEmissions(a)
  //       .then(res => {
  //         // commit("SET_ALL_POLLUTION_SOURCE_NORMATIVE", res.data.data);
  //         resolve(res);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // },

  // addDailyPollutionEmissions({ commit }, a) {
  //   return new Promise((resolve, reject) => {
  //     addObjectDailyPollutionEmissions(a)
  //       .then(res => {
  //         // commit("ADD_POLLUTION_SOURCE_NORMATIVE", a);
  //         resolve(res);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // },

  // editDailyPollutionEmissions({ commit }, a) {
  //   return new Promise((resolve, reject) => {
  //     editObjectDailyPollutionEmissions(a)
  //       .then(res => {
  //         // commit("EDIT_POLLUTION_SOURCE_NORMATIVE", a);
  //         resolve(res);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // },
};
